import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

const insights = {
  namespaced: true,
  state: () => ({
    fanbaseEvolution: {
      insights: [],
    },
    interactionsOverTime: {
      insights: [],
    },
  }),
  actions,
  getters,
  mutations,
};

export default insights;
